import { render, staticRenderFns } from "./toc.vue?vue&type=template&id=3edf0acc&"
import script from "./toc.vue?vue&type=script&lang=js&"
export * from "./toc.vue?vue&type=script&lang=js&"
import style0 from "./toc.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports